var _path, _path2, _path3, _path4, _path5, _path6, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 98,
    viewBox: "0 0 77 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.1299 1L39.3046 10.1017",
    stroke: "#FF7D23",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6904 7.10547L29.0972 12.333",
    stroke: "#FF7D23",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7535 6.49609L49.542 11.9406",
    stroke: "#FF7D23",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.2212H77V97.9262H0V47.2212Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77 47.2213H0L10.6182 20.5361H66.3818L77 47.2213Z",
    fill: "#FED3B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7978 65.8996H29.2133C27.0136 65.8996 25.2354 64.1123 25.2354 61.9015C25.2354 59.6906 27.0136 57.9033 29.2133 57.9033H47.7978C49.9975 57.9033 51.7757 59.6906 51.7757 61.9015C51.7757 64.1123 49.9975 65.8996 47.7978 65.8996Z",
    fill: "#FF7D23"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.916,
    y: 20.6807,
    width: 55.5066,
    height: 26.8608,
    fill: "#FFEADB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmpty);
export default __webpack_public_path__ + "static/media/icon_empty.52e00ff3e0b0df76406db1f4d9006825.svg";
export { ForwardRef as ReactComponent };